<div class="col-lg-12 col-xs-12 pt-125 mt-20">
  <div class="sticky" style="width: 100%; box-shadow: rgba(0, 0, 0, 0.45) 0px 20px 20px -20px; z-index: 10">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      @for (link of navLinks; track link) {
        @if (link.visible && (link.label !== 'DEMANDES D\'AVIS' || totalDemandeAvis > 0)) {
          <a
            mat-tab-link
            [routerLink]="['/' + link.route]"
            routerLinkActive
            #rla="routerLinkActive"
            [active]="isRouteActive(link.route)"
            >
            @if (link.label === 'ACCUEIL') {
              <mat-icon class="material-symbols-outlined icon-home" style="margin-right: 5px; font-size: 20px">home</mat-icon>
            }
            {{ link.label }}
          </a>
        }
      }
    </nav>
  </div>

  <mat-tab-nav-panel #tabPanel>
    <div class="m-25">
      <div class="col-12 table-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-tab-nav-panel>
</div>
